export const BILLS = [
  { number: 1,  description: 'FOUNDATIONS (PROVISIONAL)' },
  { number: 2,  description: 'CONCRETE, FORMWORK AND REINFORCEMENT' },
  { number: 3,  description: 'BRICKWORK' },
  { number: 4,  description: 'WATERPROOFING (PROVISIONAL)' },
  { number: 5,  description: 'PLASTERING AND WALL LININGS' },
  { number: 6,  description: 'PAVINGS, WALL AND FLOOR COVERINGS' },
  { number: 7,  description: 'CARPENTRY' },
  { number: 8,  description: 'JOINERY AND IRONMONGERY' },
  { number: 9,  description: 'METALWORK' },
  { number: 10, description: 'ROOF COVERINGS' },
  { number: 11, description: 'PAINTING' },
  { number: 12, description: 'SPECIALIST SERVICES' },
] as const;

export const SECTION_TO_BILL: Record<string, number> = {
  FOUNDATIONS:          1,
  'CONCRETE, FORMWORK': 2,
  BRICKWORK:            3,
  WATERPROOFING:        4,
  PLASTERING:           5,
  'FLOOR COVERINGS':    6,
  CARPENTRY:            7,
  JOINERY:              8,
  METALWORK:            9,
  'ROOF COVERINGS':    10,
  PAINTING:            11,
  'SPECIALIST SERVICES': 12,
};
